import React, { ChangeEvent, FocusEventHandler, KeyboardEventHandler } from 'react';

import { ValueInput } from '@candu-ai/craft/ui';
import { useMultiNodes } from 'craft/hooks';
import { useValidationErrorForField } from 'craft/hooks/useValidationError';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  nodeIds?: string[];
  name: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  notInBox?: boolean;
  isReadOnly?: boolean;
  hasError?: boolean;
}

export const InputField = ({ nodeIds, name, onChange, ...otherProps }: Props) => {
  const {
    props,
    collections,
    actions: { setProps },
  } = useMultiNodes(nodeIds || [], (node) => ({
    collections: node?.data.custom.collections,
  }));
  const validationError = useValidationErrorForField(nodeIds, name);

  const defaultOnChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setProps({ [name]: value });
  };

  let value = nodeIds ? props[name]?.value ?? '' : null;
  let disabled = false;

  if (collections?.length > 0) {
    value = 'Data from collection';
    disabled = true;
  }

  return (
    <ValueInput
      value={value}
      onChange={onChange || defaultOnChange}
      hasError={!!validationError?.message}
      disabled={disabled}
      {...otherProps}
    />
  );
};
